import { useTakeover } from "@/lib/influencer/influencerTakeover";

/**
 * Top-of-page takeover banner — elegant, dismissible-by-route.
 * Renders only when an influencer/tenant takeover is active.
 */
export function InfluencerTakeoverBanner() {
  const t = useTakeover();
  if (!t.active) return null;

  return (
    <div
      role="banner"
      aria-label={t.name}
      className="relative overflow-hidden rounded-2xl border border-border/60 bg-background/85 p-4 backdrop-blur"
      style={{
        boxShadow: `0 0 0 1px ${t.accent}33, 0 12px 40px -12px ${t.accent}88`,
      }}
    >
      <span
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background: `radial-gradient(80% 60% at 0% 0%, ${t.accent}26 0%, transparent 60%)`,
        }}
      />
      <div className="relative flex items-center gap-3">
        <div className="text-3xl leading-none" aria-hidden>{t.emoji}</div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
            Takeover
          </div>
          <div className="text-base font-black leading-tight">{t.slogan}</div>
          {t.challengeLabel && (
            <div className="mt-0.5 text-[11px] text-muted-foreground">
              ⚽ Challenge: <span className="font-bold text-foreground/80">{t.challengeLabel}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
